import { render, staticRenderFns } from "./ReviewTile.vue?vue&type=template&id=75dbdea0&scoped=true&"
import script from "./ReviewTile.vue?vue&type=script&lang=js&"
export * from "./ReviewTile.vue?vue&type=script&lang=js&"
import style0 from "./ReviewTile.vue?vue&type=style&index=0&id=75dbdea0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dbdea0",
  null
  
)

export default component.exports